import { render } from "./NoticeBody.vue?vue&type=template&id=5f2bc094&scoped=true"
import script from "./NoticeBody.vue?vue&type=script&lang=js"
export * from "./NoticeBody.vue?vue&type=script&lang=js"

import "./NoticeBody.vue?vue&type=style&index=0&id=5f2bc094&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2bc094"]])

export default __exports__